const $ = require("jquery");

function initPersonalDataModal() {
    let modal = document.getElementById("personal-data");
    if (modal) {
        modal.querySelector('.modal__container').style.maxWidth = '1000px';
        let modal_content = modal.querySelector('.modal__content');
        if (modal_content.innerHTML === '') {
            $.get('/personal-data')
                .done(function (response) {
                    modal.querySelector('.loading-img').style.display = 'none';
                    modal_content.innerHTML = `<h2 class="text-center">${response.page.title}</h2>` + response.page.text;
                })
                .fail(function (xhr) {
                    console.error('Ошибка:', xhr.status, xhr.statusText);
                });
        }
    }
}
export default  initPersonalDataModal;
